import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

const CategorySection = () => {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            探索分类
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            按类型发现你感兴趣的韩国漫画
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 md:p-6 rounded-xl bg-background-50 hover:bg-primary-50 transition-all cursor-pointer no-underline border border-background-200/70 hover:border-primary-200"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 dark:group-hover:text-foreground-950 transition-all">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-700 transition-colors font-heading whitespace-nowrap">
                {cat.name}
              </span>
              <p className="text-xs text-foreground-500 text-center leading-relaxed hidden sm:block">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategorySection;